import { createFileRoute } from '@tanstack/react-router'
import BranchTransferStock from './-components'
import { pharmacyClient } from '@/connect'

export const Route = createFileRoute('/(inventory)/branch/_layout/inventory/transfer-stock/' as any)({
  component: BranchTransferStock,
  loader: async () => {
    return await pharmacyClient.getBranchesForCompany({
      companyCode: '', 
    })
  }
})